import { render, staticRenderFns } from "./TabRowConfigurationView.vue?vue&type=template&id=6a83fac6"
import script from "./TabRowConfigurationView.vue?vue&type=script&lang=js"
export * from "./TabRowConfigurationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports